//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export enum InstagramPostStatus {
  Canceled = 'canceled',
  Failed = 'failed',
  FailedRescheduled = 'failed_rescheduled',
  Notified = 'notified',
  Pending = 'pending',
  Posted = 'posted',
  Scheduled = 'scheduled',
}

export function isPostStatusFailure(status: InstagramPostStatus) {
  switch (status) {
    case InstagramPostStatus.Failed:
    case InstagramPostStatus.FailedRescheduled:
      return true;
    default:
      return false;
  }
}
